export default __webpack_public_path__ + "static/media/pic11.f1feb98d.jpg";